import React from 'react'
import "./Style/Style.css";
const Copyright = () => {
  return (
    <div>
       <div className="copyright">
            <p> Created By Vishnu singh rajput | All Rights Reserved</p>
        </div>
    </div>
  )
}

export default Copyright
